import React, { useEffect } from 'react'
import { get , isEmpty } from 'lodash'
import {  connect, useDispatch } from 'react-redux'
import { GET_PACKAGE, GET_SUB_SCRIPTION, PAYMENT_HISTORY } from '../../redux/actions/type'
import { Views } from '../../views'


const Error = ({ keycloak }) => {

    const dispatch = useDispatch()
    const { Error } = Views

    useEffect(() => {
        if (!isEmpty(keycloak) && !keycloak.authenticated) {
            window.location.href = '/portal'
        }
    }, [keycloak])

    useEffect(() => {
        if (!isEmpty(keycloak) && keycloak.authenticated) {
            dispatch({
                type: GET_SUB_SCRIPTION
            })
            dispatch({
                type: GET_PACKAGE
            })
            dispatch({
                type: PAYMENT_HISTORY
            })
        }
    }, [dispatch, keycloak])


    return (
        !isEmpty(keycloak) && keycloak.authenticated ? (
            <Error />
        ) : null
    )
}

const mapStateToProps = state => ({
    keycloak: get(state, "keycloak", "")
})
export default connect(mapStateToProps, {})(Error)